<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Halftitle">
<p class="half-title"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii">THE FATHER OF <br/>JEWISH MYSTICISM<span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253062093_Halftitle1.vue?5efef4f5